import * as requestFromServer from "./TasksCrud";
import { tasksSlice, callTypes } from "./TasksSlice";

const { actions } = tasksSlice;

// Action Creator: fetches a list of tasks from the server
export const fetchTasks = (queryParams) => (dispatch) => {
  // Dispatch action to indicate an API call has started
  dispatch(actions.startCall({ callType: callTypes.list }));
  // Dispatch action to update the task list with loading state
  dispatch(
    actions.tasksFetched({ totalCount: 0, entities: [], loading: true })
  );
  // Make a GET request to the server to fetch tasks
  return requestFromServer
    .findTasks(queryParams)
    .then((response) => {
      // Extract meta data and task list from server response
      const { meta, data } = response.data;
      // Dispatch action to update the task list with the fetched data
      dispatch(
        actions.tasksFetched({
          totalCount: meta.total,
          entities: data,
          loading: false,
        })
      );
    })
    .catch((error) => {
      // Add a client message to the error object
      error.clientMessage = "Can't find products";
      // Dispatch action to handle the error
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

// Action Creator: searches for a task on the server
export const fetchSearchTask = (queryParams) => (dispatch) => {
  // Dispatch action to indicate an API call has started
  dispatch(actions.startCall({ callType: callTypes.list }));
  // Make a GET request to the server to search for a task
  return requestFromServer
    .searchTaskApi(queryParams)
    .then((response) => {
      // Extract the task data from the server response
      const { data } = response.data;
      // Dispatch action to update the task list with the search results
      dispatch(actions.searchTask({ data }));
    })
    .catch((error) => {
      // Add a client message to the error object
      error.clientMessage = "Can't find products";
      // Dispatch action to handle the error
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
